module.exports = __webpack_public_path__ + "img/prize-05.f9f93b49.png";